import { frontendURL } from 'dashboard/helper/URLHelper';

import SettingsWrapper from '../SettingsWrapper.vue';
import AgentPauseTypesHome from './Index.vue';
import AgentPauseTypesNew from './New.vue';
import AgentPauseTypesEdit from './Edit.vue';

export default {
  routes: [
    {
      path: frontendURL('accounts/:accountId/settings/agent-pause-types'),
      component: SettingsWrapper,
      children: [
        {
          path: '',
          redirect: 'list',
        },
        {
          path: 'list',
          name: 'agent_pause_types_list',
          meta: {
            permissions: ['administrator'],
          },
          component: AgentPauseTypesHome,
        },
        {
          path: 'new',
          name: 'agent_pause_types_new',
          meta: {
            permissions: ['administrator'],
          },
          component: AgentPauseTypesNew,
        },
        {
          path: ':pauseTypeId/edit',
          name: 'agent_pause_types_edit',
          meta: {
            permissions: ['administrator'],
          },
          component: AgentPauseTypesEdit,
        },
      ],
    },
  ],
};
